import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export enum PackingSlipLineItemKeys {
  itemNumber = 'itemNumber', // line item number, not to be entered by user
  itemName = 'itemName', // name of the item, often SKU, Unique ID, reference ID, etc
  description = 'description', // verbose description of the item (human parseable)
  itemQty = 'itemQty', // quantity of the item for order
}

export const stlPackingSlipFileDataSchema = yup.object().shape({
  buyer: yup.object().shape({
    companyName: yup.string().nullable().optional(),
    address: yup.string().nullable().optional(),
    contactName: yup.string().nullable().optional(),
    phoneNumber: yup.string().nullable().optional(),
    emailAddress: yup.string().nullable().optional(),
  }),
  stlPackingSlipNumber: yup.string().nullable().optional(),
  customerPoNumber: yup.string().nullable().optional(),
  date: yup.string().nullable().optional(),
  vendor: yup.object().shape({
    companyName: yup.string().nullable().optional(),
    address: yup.string().nullable().optional(),
    contactName: yup.string().nullable().optional(),
    phoneNumber: yup.string().nullable().optional(),
    emailAddress: yup.string().nullable().optional(),
  }),
  destination: yup.object().shape({
    companyName: yup.string().nullable().optional(),
    address: yup.string().nullable().optional(),
    contactName: yup.string().nullable().optional(),
    phoneNumber: yup.string().nullable().optional(),
    emailAddress: yup.string().nullable().optional(),
  }),
  items: yup
    .array()
    .of(
      yup.object().shape({
        [PackingSlipLineItemKeys.itemNumber]: yup.number().nullable().optional(),
        [PackingSlipLineItemKeys.itemName]: yup.string().nullable().optional(),
        [PackingSlipLineItemKeys.description]: yup.string().nullable().optional(),
        [PackingSlipLineItemKeys.itemQty]: yup.string().nullable().optional(),
      }),
    )
    .required(),
  notes: yup.string().nullable().optional(),
  shipVia: yup.string().nullable().optional(),
  footerText: yup.string().nullable().optional(),
})

export type StlPackingSlipFileData = yup.InferType<typeof stlPackingSlipFileDataSchema>
type RequiredFileData = MakeRequiredAndNullable<StlPackingSlipFileData>

export const stlPackingSlipFileMappings: RequiredFileData = {
  buyer: {
    companyName: '6a657d2a-1186-4632-9c21-dbdbaeddb5c1',
    address: '3fe50f9f-f628-4d4c-8898-3f7035f8ee53',
    contactName: '7f042284-a6ab-4162-bfa6-e5066e7550b0',
    phoneNumber: '1bd418a4-78ee-4154-9b74-ef79d5438027',
    emailAddress: '59622cd2-8fc3-4903-bf30-774dc5547fba',
  },
  stlPackingSlipNumber: '4065ad17-982a-4e00-9f7f-55be83bbabe7',
  customerPoNumber: '51b2d564-137d-4b83-8791-20f8cbe92257',
  date: '7a657e3d-88f4-4097-8970-0ff00c8ee90a',
  vendor: {
    companyName: '7f91018c-0cc9-451a-92d3-0dd62477841d',
    address: 'edde1c2f-20aa-47c8-99a6-dfccea78dcd2',
    contactName: '2d31e181-3da1-4720-aad6-051ffa564d9e',
    phoneNumber: 'fb63607f-d506-4c6c-a6ae-44bb123ec967',
    emailAddress: '981d8bc1-40ed-4602-a03c-48a6333c6174',
  },
  destination: {
    companyName: '4c058185-c1b5-47a0-9285-3f7e50025f7c',
    address: '67729604-34d4-4a50-baa5-f14b519d0722',
    contactName: '0d9be62a-53b1-427b-8c4d-e7ea9c757fbe',
    phoneNumber: 'd38f8a3b-d66f-4dae-aed0-e953e64d7937',
    emailAddress: 'fed5bd45-1a74-4d93-828c-5c566d37cb2f',
  },
  items: [
    {
      itemNumber: null,
      itemName: '6a406ea7-7ca3-4ea1-91cd-bb834499bcd8',
      description: '60f4fbfe-188a-4791-8273-9325677d2071',
      itemQty: 'bf2fcce7-2c12-404c-92ff-9a96000f7479',
    },
  ],
  notes: 'f78922c4-bcf7-4dfd-9a3c-bad602b38e96',
  shipVia: 'd4e3e2f3-2f1a-4e2b-8f7a-5c6e5d9b8a1c',
  footerText: 'd1165b77-c2b1-4ba9-98ee-db758eb2c028',
}
